import { SystemTypeEnum } from "./shared-enums";

type CanCreateEntryFormInput = {
  hasSupervisorAccess: boolean;
  isFullSuperadmin: boolean;
  systemType?: string | null;
};

/**
 * Returns whether a user may create an Entry Form for the supplied system.
 * Full superadmins are allowed for every system type; all other users require
 * Supervisor access to an Industrial system.
 */
export const canCreateEntryForm = ({
  hasSupervisorAccess,
  isFullSuperadmin,
  systemType,
}: CanCreateEntryFormInput): boolean => {
  return isFullSuperadmin || (hasSupervisorAccess && systemType === SystemTypeEnum.INDUSTRIAL);
};
